import * as React from 'react';
import { SVGProps } from 'react';

const SvgXRay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="m19.06 33.339-2.214-.706 1.788-5.571c.174-.516.47-.983.863-1.36.265-.298.516-.58.516-.79a.53.53 0 0 0-.335-.172l-.046.028a2.322 2.322 0 0 1-1.676.404 2.702 2.702 0 0 1-1.676-.984l-.098-.107h-.046a.85.85 0 0 0-.413.989c.041.149.357.418.585.608.603.516 1.62 1.393 1.216 2.823v.051l-1.5 4.471-2.205-.729 1.458-4.41a4.119 4.119 0 0 0-.464-.442 3.602 3.602 0 0 1-1.324-1.773 3.157 3.157 0 0 1 2.043-3.84 2.234 2.234 0 0 1 2.47.776c.186.204.223.232.288.246l.111-.07a2.085 2.085 0 0 1 1.366-.395 2.665 2.665 0 0 1 2.572 2.503 3.51 3.51 0 0 1-1.105 2.321c-.138.143-.26.298-.367.465l-1.806 5.664Zm2.536-11.069a2.228 2.228 0 0 1-2.173-1.392c-.125-.247-.153-.284-.214-.311l-.12.037a2.14 2.14 0 0 1-1.426.027 2.665 2.665 0 0 1-1.857-3.078c.284-.845.88-1.55 1.667-1.968a2.54 2.54 0 0 0 .464-.349l2.465-4.076 1.988 1.203-2.456 4.085c-.302.456-.71.832-1.189 1.096-.33.223-.645.427-.697.627a.51.51 0 0 0 .275.255h.055a2.321 2.321 0 0 1 1.723.047c.623.272 1.12.77 1.393 1.392.018.044.04.085.065.126h.046a.85.85 0 0 0 .655-.85 2.274 2.274 0 0 0-.409-.738c-.464-.65-1.212-1.741-.464-3.041l.13-.177 3.519-4.011 1.746 1.527-3.376 3.845c.1.184.211.36.335.529.48.582.77 1.3.826 2.052a3.157 3.157 0 0 1-2.971 3.143Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M12.674 5.4H8.2v30h25v-30h-4.373"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M29.45 8.65h-17.5v-5.5h17.5v5.5Z"
    />
    <path
      fill="currentColor"
      d="M15.313 6.804a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804Zm11.147 0a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804Z"
    />
    <path fill={props.fill} d="M7.5 36.25v-4.62l20.893-.023 4.652 4.643H7.5Z" />
  </svg>
);

export default SvgXRay;
